import apiClient from '@/services/axios'

export async function post() {
    var response = await apiClient.post(process.env.VUE_APP_CRM_API_BASE_URL + '/EngageEmail/EmailSignature')
    if (response) {
        return response.data
    }

    throw new Error('Unable to create email signature')
}